import React from 'react';
import AuthService from './authService';
import SearchParams from '../Elements/SearchParams';
import TpClientPaymentTpClientInvoiceSearchParams from '../Contents/ThirdParty/TpClientPayment/TpClientPaymentTpClientInvoiceSearchParams';

export default class TpRelatedClientInvoiceService extends React.Component {
  static ListTpRelatedOutstanding(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache) {
    const searchParams = new SearchParams(searchItem, TpClientPaymentTpClientInvoiceSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    return AuthService.getInstance().CallBackendFunction(
      `/api/TpRelatedClientInvoice/ListTpRelatedOutstandingAsync/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=true`
    );
  }

  static ListTpRelatedApplied(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache) {
    const searchParams = new SearchParams(searchItem, TpClientPaymentTpClientInvoiceSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    return AuthService.getInstance().CallBackendFunction(
      `/api/TpRelatedClientInvoice/ListTpRelatedAppliedAsync/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=true`
    );
  }
}
